// extracted by mini-css-extract-plugin
export default {"container":"TablePlaceholder__container___Ny0Y5","item":"TablePlaceholder__item___uQkRL","itemMobile":"TablePlaceholder__itemMobile___EyqYC"};